import React from "react";

const News = () => {
  return (
    <div className="each-container" id="news-container">
      <div className="awards-part">
        <div id="news">
          <div className="title">News</div>
          <div className="scrollable-content">
          <ul>
          <li>
              <b>May 2026</b> Presented a paper at CHI 2026 📍Barcelona, Spain
            </li>
          <li>
              <b>Mar 2026</b> One paper was accepted by {" "}
              <a
                href="https://www.tandfonline.com/journals/hihc20"
                target="_blank"
              >
                IJHCI
              </a>{" "}, exploring how to design technologies that support mentoring within Chinese design teams.
            </li>
          <li>
              <b>Mar 2026</b> Two papers were accepted by {" "}
              <a
                href="http://chi2026.acm.org"
                target="_blank"
              >
                CHI 2026
              </a>{" "}. The first is a systematic review examining how HCI research has designed technologies to support reminiscence, proposing a cue-centered framework. The second explores an ambient projection system that provides subtle posture feedback during desk-based study, encouraging healthier sitting habits without disrupting attention.
            </li>
          <li>
              <b>Oct 2025</b> Presented a paper at CSCW 2025 📍Bergen, Norway
            </li>
          <li>
              <b>Apr 2025</b> Presented a paper at CHI 2025 📍Yokohama, Japan
            </li>
          <li>
              <b>Mar 2025</b> A paper that explores the effects of background color and gender on visual attention has been accepted by {" "}
              <a
                href="https://www.aic-color.org"
                target="_blank"
              >
                JAIC 2025
              </a>{" "}.
            </li>
          <li>
              <b>Jan 2025</b> Two papers were accepted by {" "}
              <a
                href="http://chi2025.acm.org"
                target="_blank"
              >
                CHI 2025
              </a>{" "}. The first is an empirical study exploring how practitioners conduct ability assessments of older adults within the context of technology-mediated elderly care. 
              The second, ReminiBuddy, is from my internship at Lenovo Research and focuses on designing an LLM-powered conversational reminiscence system for older adults.
              Congrats to all the co-authors!
            </li>
          <li>
              <b>Dec 2024</b> I'm happy to share that our paper on understanding photo-based reminiscence for older adults (my first first-authored paper!) has been accepted to {" "}
              <a
                href="https://cscw.acm.org/2025/"
                target="_blank"
              >
                CSCW 2025
              </a>{" "}. A big thank you to everyone who contributed to this work. 😊
            </li>
          <li>
              <b>Sept 2024</b> Our paper on gender differences in the impact of color on cognitive performance received the Best Paper Award at {" "}
              <a
                href="https://aic2024.org"
                target="_blank"
              >
                AIC 2024
              </a>{" "}
            </li>
            <li>
              <b>Aug 2024</b> Our paper on exploring vision large language models to facilitate search in VR was accepted by {" "}
              <a
                href="https://vrst.hosting.acm.org/vrst2024/"
                target="_blank"
              >
                VRST 2024
              </a>{" "}
            </li>
          <li>
              <b>Aug 2023</b> Exited to pursue my Ph.D. at HKUST(GZ) working with {" "}
              <a
                href="https://www.mingmingfan.com"
                target="_blank"
              >
                Prof. Mingming Fan
              </a>{" "}
            </li>
            <li>
              <b>Dec 2022</b> Our urban farming design project "Pebble" is{" "}
              <a
                href="https://naturexdesign.tealeaves.com/pebble-the-ritual-of-urban-farming/"
                target="_blank"
              >
                featured
              </a>{" "}
              in NATURE X DESIGN by TEALEAVES
            </li>
            <li>
              <b>July 2022</b> I started my masters in{" "}
              <a href="https://design.engineering.brown.edu" target="_blank">
                Design Engineering
              </a>{" "}
              at Brown and RISD
            </li>
          </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
